// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"87":"jobs","353":"contact","594":"about","927":"synthesis","946":"news","962":"home","983":"products"}[chunkId] || chunkId) + "-legacy." + {"87":"282550d8","353":"3ee5b88a","594":"bf3b0f56","721":"9c93651e","927":"a621ed9f","946":"86d8bf46","962":"81734a0d","983":"866ebf16"}[chunkId] + ".js";
};